import { navigate } from "gatsby"
import analytics from "@mobi/libraries/analytics"
import { useForm, useController } from "react-hook-form"
import { isValidCpfCnpj } from "utils/verifyIfIsCpfCnpj"
import { useLocation } from "@reach/router"
import { MOCK_EMAIL, MOCK_NAME } from "gatsby-env-variables"
import tracking from "../../trackings"
import { useEffect } from "react"

const useHero = () => {
  const location = useLocation()
  const locationState = location?.state
  const locationFormData = locationState?.formData

  const formProps = useForm({
    mode: "onChange",
    defaultValues: locationFormData || {
      document: "",
      phone: "",
    },
  })

  const handleSubmitForm = (event) => {
    event.preventDefault()

    if (isValid) {
      tracking.formButtonClick()

      const formValues = formProps.getValues()
      formValues.email = MOCK_EMAIL
      formValues.name = MOCK_NAME

      navigate("/carregando", { state: { formValues } })
    }
  }

  const {
    control,
    formState: { isValid },
  } = formProps

  const { field } = useController({
    name: "document",
    control,
    defaultValue: "",
    rules: {
      required: true,
    },
  })

  const documentValue = field.value.replace(/\D/g, "")
  const isValidDocument = isValidCpfCnpj(documentValue)

  useEffect(() => {
    if (!isValidDocument) return

    analytics.track("segmentPageView", "Registro")
    analytics.track("segmentElementViewed", "CardExpansivo")
    tracking.documentValidation()
  }, [isValidDocument])

  return {
    isValid,
    isValidDocument,
    field,
    control,
    handleSubmitForm,
  }
}

export default useHero
